import {ICompetition} from '@components/competitions/ICompetitions';
import {createContext, useContext} from 'react';

type ContextType = {
	competition: ICompetition,
	mission: number,
	setMission: (_value: number) => void,
	phone: string,
	setPhone: (_value: string) => void,
	day: number,
	setDay: (_value: number) => void,
	answers: {[key: string]: number | null};
	setAnswers: (_value: {[key: string]: number | null}) => void;
	correctAnswers: number[];
	setCorrectAnswers: (_value: number[]) => void;	// referralCode: string
	// setReferralCode: (_value: string) => void,
	// referrerFrom: string
};
const CompetitionTekyehmajaziContext = createContext<ContextType>({
	competition: {} as ICompetition,
	mission: 0,
	setMission: (_value: number) => {
	},
	
	answers: {},
	setAnswers: (_value: {[key: string]: number | null}) => {
	},
	
	phone: '',
	setPhone: (_value: string) => {
	},
	
	day: 0,
	setDay: (_value: number) => {
	},
	
	correctAnswers: [],
	setCorrectAnswers: (_value: number[] | ((prev: number[]) => number[])) => {
	}
});

const useCompetitionTekyehmajaziContext = () => useContext(CompetitionTekyehmajaziContext);
export {
	CompetitionTekyehmajaziContext,
	useCompetitionTekyehmajaziContext
};
